import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout, mobileAbout2 } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mv="15px">
          <CFImage src={about} w="100%" alt="Yanaki Sushi About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          alignCenter
          h="550px"
          w="100%"
          maxWidth="1400px"
          image={`url(${about}) 40% 0% / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          m="0 auto"
          mt="-1px"
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
